import FlexButtons from "../../../../../../../../components/FlexButtons";
import { getLabel } from "../../../../../../../../hooks/use-labels";
import HexButton from "../../../../../../../../ui-kit/HexButtons";

const TimelineFooter = ({ onBack, onSave, disable }) => {
  return (
    <FlexButtons className={"mt-24"}>
      <HexButton
        size="md"
        type={"outline"}
        className="full-width"
        label={getLabel("backLabel")}
        onClick={onBack}
      />

      <HexButton
        label={getLabel("saveLabel")}
        onClick={onSave}
        type="primary"
        size="md"
        htmlType="submit"
        disable={disable}
        className="full-width delivery-save-button"
      />
    </FlexButtons>
  );
};

export default TimelineFooter;
